// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.unsplash-logo svg[data-v-6c94c06a] {\n  height: 12px;\n  width: auto;\n  position: relative;\n  vertical-align: middle;\n  top: -2px;\n  fill: white;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
